<template>
  <div class="shadow-none">
    <div>
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <ReconcilationHeader
          :activeTabProp="activeSubTab"
          :hasPermission="hasPermission"
          @switchTab="switchSubTab"
          :viewFilter="viewFilter"
          :viewFilterPR="viewFilterPR"
        />
        <div v-if="activeSubTab === 'pending'">
          <div class="table-responsive">
            <table class="table dataTable text-nowrap">
              <thead class="bg-white">
                <tr>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Product
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Order Number
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Fulfiled Date
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Customer Name
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Quantity Reconciled
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Order Value (₦)
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Reconcile Type
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr v-if="isLoading">
                  <td colspan="12" class="text-center">
                    <div
                      class="text-center"
                      style="padding-top: 100px; padding-bottom: 50px"
                    >
                      <span
                        class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                        style="font-size: 8rem"
                      ></span>
                      <h3
                        class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                        style="padding-bottom: 100px"
                      >
                        Please wait while we load the list
                      </h3>
                    </div>
                  </td>
                </tr>
                <tr v-for="prs in pendingOrdersToStocks" :key="prs.id" v-else>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ prs.productName }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ prs.orderNumber }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ formatDate(prs.fulfilledDate) }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ prs.customerName }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ prs.quantity }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ formatMoney(prs.sellPrice) }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ prs.reconciliationMode || "MANUAL" }}
                  </td>
                  <td>
                    <div
                      class="text-right"
                      v-if="hasPermission('Inventory_Reconcile_Stock_Update')"
                    >
                      <button
                        v-if="prs.status == 'Fulfilled'"
                        class="btn btn-success btn-sm btn-rounded btn-space"
                        @click.prevent="viewEdit(prs)"
                      >
                        Reconcile Stock
                      </button>

                      <button
                        v-else
                        class="btn btn-primary btn-sm btn-rounded btn-space"
                        disabled
                      >
                        {{ prs.status }}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!pendingOrdersToStocks.length && !isLoading">
                  <td colspan="8">
                    <div class="text-center" style="padding-top: 50px">
                      <span
                        style="font-size: 4.615rem"
                        class="mdi mdi-crosshairs-gps"
                      ></span>
                    </div>
                    <h3 class="text-center" style="padding-bottom: 100px">
                      You don't have any orders to reconcile.
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination
              :limit="pendingOrder.pageSize"
              :count="pendingOrder.pageCount"
              :page="pendingOrder.page"
              :itemsCount="pendingOrder.count"
              @changePage="gotoPagePending"
              @changeLimit="changeLimitPending"
            />
          </div>
        </div>
      </div>
      <div v-if="activeSubTab === 'reconcile'">
        <div class="table-responsive">
          <table class="table dataTable text-nowrap">
            <thead class="bg-white">
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Product
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Order Number
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Fulfiled Date
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Customer Name
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Quantity
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Order Value (₦)
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Reconcile Type
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div
                    class="text-center"
                    style="padding-top: 100px; padding-bottom: 50px"
                  >
                    <span
                      class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                      style="font-size: 8rem"
                    ></span>
                    <h3
                      class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px"
                    >
                      Please wait while we load the lists
                    </h3>
                  </div>
                </td>
              </tr>
              <tr v-for="l in ReconcileOrdersToStocks" :key="l.id" v-else>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.productName }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.orderNumber }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ formatDate(l.fulfilledDate) }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.customerName }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.quantity }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ formatMoney(l.sellPrice) }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.reconciliationMode || "MANUAL" }}
                </td>
                <td>
                  <button
                    class="text-[14px] font-normal leading-[16.94px] outline-none focus:outline-none text-[#96A0B5]"
                    @click.prevent="
                      getOrderreconcilationDetails(l.orderDetailId)
                    "
                  >
                    View
                  </button>
                </td>
              </tr>
              <tr v-if="!ReconcileOrdersToStocks.length && !loading">
                <td colspan="8">
                  <div class="text-center" style="padding-top: 50px">
                    <span
                      style="font-size: 4.615rem"
                      class="mdi mdi-crosshairs-gps"
                    ></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom: 100px">
                    You don't have any orders to reconcile.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :limit="reconciledOrder.pageSize"
            :count="reconciledOrder.pageCount"
            :page="reconciledOrder.page"
            :itemsCount="reconciledOrder.count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-edit"
      role="dialog"
    >
      <div class="modal-dialog modal-lg">
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4 class="modal-title p-1"><b>Reconcile Orders To Stock</b></h4>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
              @click="cancel"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="p-0 m-0">
            <div class="pb-[16px]" v-if="!v1.is_valid">
              <div class="col-12 col-sm-12 col-lg-12">
                <label
                  class="col-12 col-sm-12 text-sm-center alert alert-danger"
                  >{{ v1.text }}</label
                >
              </div>
            </div>

            <div class="pb-[16px]">
              <label class="col-4 col-sm-12 col-form-label text-sm-left"
                ><b>Customer:</b>
                {{ updateReconcileOrdersToStock.customerName }}</label
              >
              <label class="col-4 col-sm-6 col-form-label text-sm-left"
                ><b>Product:</b>
                {{ updateReconcileOrdersToStock.productName }} ({{
                  updateReconcileOrdersToStock.productUnit
                }})
              </label>
              <label class="col-4 col-sm-6 col-form-label text-sm-left"
                ><b>Qty:</b> {{ updateReconcileOrdersToStock.quantity }}</label
              >
            </div>
            <div class="pb-[16px]">
              <div class="col-12 col-sm-12 col-lg-12 table-responsive">
                <table
                  class="table table-fw-widget dataTable no-footer text-nowrap"
                >
                  <thead>
                    <tr>
                      <th style="width: 15%">Inventory Id</th>
                      <th style="width: 20%">Location</th>
                      <th style="width: 15%">Product Batch Id</th>
                      <th style="width: 10%">Expiry Date</th>
                      <th style="width: 15%">Cost Price</th>
                      <th style="width: 10%">Qty</th>
                      <th style="width: 15%">Sales</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(l,
                      key) in updateReconcileOrdersToStock.productInventories"
                      :key="l.id"
                    >
                      <td>
                        {{ l.inventoryId }}
                      </td>
                      <td>{{ l.warehouseName }}, {{ l.storageAreaName }}</td>
                      <td>
                        {{ l.productBatchId }}
                      </td>
                      <td>
                        {{ l.expiryDate ? formatDate(l.expiryDate) : "" }}
                      </td>
                      <td>{{ l.costPrice }}</td>
                      <td>{{ l.quantityInStock }}</td>
                      <td>
                        <input
                          :class="[
                            'form-control',
                            {
                              'is-invalid': !v1.quantities[key].quantity
                                .is_valid,
                            },
                          ]"
                          type="number"
                          v-model="l.quantitySold"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              style="width: 100px"
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
              @click="cancel"
            >
              Cancel
            </button>
            <button
              style="width: 150px"
              :disabled="isBusyModal"
              class="btn btn-primary"
              type="button"
              @click.prevent="reconcile"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Reconcile Stock</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-filter" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] min-h-screen"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="p-0 m-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Product name</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter product name..."
                  v-model="filter.pn"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Product Code</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter product code..."
                  v-model="filter.pc"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Order Number</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter product code..."
                  v-model="filter.on"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Customer Name</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select a customer"
                  v-model="filter.cn"
                >
                  <option v-for="c in customers" :key="c.id" :value="c.id">
                    {{ c.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Reconcile Type</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.reconcileType"
                >
                  <option key="0" value="MANUAL">Manual</option>
                  <option key="1" value="AUTOMATIC">Automatic</option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Date Start</label
              >
              <input
                type="date"
                :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a date"
                v-model="filter.startDate"
              />
            </div>
            <div>
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Date End</label
              >
              <input
                type="date"
                :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a date"
                v-model="filter.endDate"
              />
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="getReconcileOrdersToStocks"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="mod-filterPR" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] min-h-screen"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="p-0 m-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Product name</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter product name..."
                  v-model="filter1.pn"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Product Code</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter product code..."
                  v-model="filter1.pc"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Order Number</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter product code..."
                  v-model="filter1.on"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Customer Name</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select a customer"
                  v-model="filter1.cn"
                >
                  <option v-for="c in customers" :key="c.id" :value="c.id">
                    {{ c.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Date Start</label
              >
              <input
                type="date"
                :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a date"
                v-model="filter1.startDate"
              />
            </div>

            <div>
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Date End</label
              >
              <input
                type="date"
                :max="maxDate"
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                placeholder="Select a date"
                v-model="filter1.endDate"
              />
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="resetPR"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="getPendingOrder"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-warning"
      role="dialog"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-centered"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4 class="modal-title p-1"><strong>Stock Details</strong></h4>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="p-0 m-0">
            <p>{{}}</p>
          </div>
        </div>
      </div>
    </div>
    <reconciledModal
      :closeModal="closeModal"
      :reconciledDetails="reconciledDetails"
      v-if="isModalVisible"
    />
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import Pagination from "../components/Pagination.vue";
import SystemPermissions from "@/permissions";
import ReconcilationHeader from "../components/Inventory/ReconcilationHeader.vue";
import reconciledModal from "../components/Inventory/reconciledModal.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsReconcileOrdersToStocks",
  components: {
    Select2,
    Pagination,
    ReconcilationHeader,
    reconciledModal,
  },

  created() {
    if (!this.hasPermission("Inventory_Reconcile_Stock_View")) {
      this.$router.push("/restricted");
    }
    this.getCustomers();
    this.getPendingOrder();
    this.getReconcileOrdersToStocks();
  },

  data() {
    return {
      activeSubTab: "pending",

      filter: {
        pn: "",
        pc: "",
        cn: "",
        on: "",
        isReconciled: "0",
        reconcileType: "",
        startDate: "",
        endDate: "",
      },
      filter1: {
        pn: "",
        pc: "",
        cn: "",
        on: "",
        isReconciled: "0",
        reconcileType: "",
        startDate: "",
        endDate: "",
      },
      customers: [],

      reconciledDetails: {
        name: "",
        code: "",
        product: "",
        quantity: "",
        list: [],
      },

      isBusy: false,
      isBusyModal: false,
      isModalVisible: false,
      loading: false,
      isLoading: false,
      updateReconcileOrdersToStock: {
        productCode: null,
        orderId: null,
        orderName: null,
        orderDetailId: null,
        quantity: null,
        fulfilledDate: null,
        customerName: null,
        sellPrice: null,
        productInventories: [],
        id: null,
      },

      v1: {
        quantities: [],
        is_valid: true,
        text: "",
      },

      ReconcileOrdersToStocks: [],
      pendingOrdersToStocks: [],
      reconciledOrder: {
        count: 0,
        page: 1,
        pageSize: 10,
        pageCount: 0,
        hasNext: false,
        hasPrev: false,
      },
      pendingOrder: {
        count: 0,
        page: 1,
        pageSize: 10,
        pageCount: 0,
        hasNext: false,
        hasPrev: false,
      },
      options: {
        format: "YYYY-MM-DD",
        icons: {
          time: "mdi mdi-time",
          date: "mdi mdi-calendar",
          up: "mdi mdi-chevron-up",
          down: "mdi mdi-chevron-down",
          previous: "mdi mdi-chevron-left",
          next: "mdi mdi-chevron-right",
          today: "mdi mdi-screenshot",
          clear: "mdi mdi-trash",
          close: "mdi mdi-remove",
        },
      },

      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Select Hour", // tip of select hour
        minuteTip: "Select Minute", // tip of select minute
        secondTip: "Select Second", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks
        cancelTip: "cancel",
        submitTip: "confirm",
      },
      maxDate: "",
      warningMessage: "This is a message from the backend",
    };
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
    this.toggleWarning();
  },

  methods: {
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
    },
    switchSubTab(subTab) {
      this.activeSubTab = subTab;
    },
    reset() {
      this.filter = {
        pn: "",
        pc: "",
        cn: "",
        on: "",
        isReconciled: "0",
        reconcileType: "",
        startDate: "",
        endDate: "",
      };
      this.getReconcileOrdersToStocks();
    },
    resetPR() {
      this.filter1 = {
        pn: "",
        pc: "",
        cn: "",
        on: "",
        isReconciled: "0",
        reconcileType: "",
        startDate: "",
        endDate: "",
      };
      this.getPendingOrder();
    },

    toggleWarning() {
      $("mod-warning").modal("show");
    },

    async getCustomers() {
      await this.$http
        .get("/Users/getItemListOfCustomers/" + this.user.parentId)
        .then(function(res) {
          this.customers = res.body;
        })
        .catch(function() {});
    },

    viewExport() {
      //   $("#mod-export").modal("show");
    },
    viewDetails(c) {
      $("#mod-details").modal("show");
    },

    viewEdit(c) {
      this.updateReconcileOrdersToStock = c;
      for (
        let i = 0;
        i < this.updateReconcileOrdersToStock.productInventories.length;
        i++
      ) {
        this.v1.quantities.push({
          quantity: {
            is_valid: true,
            text: "",
          },
        });
      }

      $("#mod-edit").modal("show");
    },

    cancel() {
      for (let i = 0; i < this.v1.quantities.length; i++) {
        this.v1.quantities[i].quantity.is_valid = true;
        this.v1.quantities[i].quantity.text = "";
      }

      this.v1.text = "";
      this.v1.is_valid = true;
    },

    viewFilter() {
      this.page = 0;
      $("#mod-filter").modal("show");
    },
    viewFilterPR() {
      this.page = 0;
      $("#mod-filterPR").modal("show");
    },

    async reconcile() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        orderId: this.updateReconcileOrdersToStock.orderId,
        inventoryItems: this.updateReconcileOrdersToStock.productInventories,
      };

      if (this.validateUpdate()) {
        $("#mod-edit").modal("hide");

        await this.$http
          .post("/Orders/reconciliation", data)
          .then(function(res) {
            this.isBusyModal = false;
            this.getCustomers();
            this.getPendingOrder();
            this.getReconcileOrdersToStocks();
          })
          .catch(function() {});
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateUpdate() {
      for (let i = 0; i < this.v1.quantities.length; i++) {
        this.v1.quantities[i].quantity.is_valid = true;
        this.v1.quantities[i].quantity.text = "";
      }

      this.v1.text = "";
      this.v1.is_valid = true;
      var isValid = true;

      let total = 0;
      this.updateReconcileOrdersToStock.productInventories.forEach((item) => {
        total += parseFloat(item.quantitySold);
      });

      if (total === 0) {
        this.v1.is_valid = false;
        this.v1.text = "Total quantities sold cannot be zero";
        isValid = false;
      }

      if (isValid) {
        for (
          let k = 0;
          k < this.updateReconcileOrdersToStock.productInventories.length;
          k++
        ) {
          let qtySold = parseInt(
            this.updateReconcileOrdersToStock.productInventories[k].quantitySold
          );
          if (!Number.isInteger(qtySold)) {
            /*
	                           this.v1.quantities[k].quantity.text = 'Please enter a valid number'; */
            this.v1.quantities[k].quantity.is_valid = false;
            this.v1.is_valid = false;
            this.v1.text = "Please enter a valid number";
            isValid = false;
          } else {
            if (
              this.updateReconcileOrdersToStock.productInventories[k]
                .quantitySold >
              this.updateReconcileOrdersToStock.productInventories[k]
                .quantityInStock
            ) {
              /*
	                               this.v1.quantities[k].quantity.text = 'Quantity sold cannot be more than quantity in stock'; */
              this.v1.quantities[k].quantity.is_valid = false;
              this.v1.is_valid = false;
              this.v1.text =
                "Quantity sold cannot be more than quantity in stock";
              isValid = false;
            }
            if (
              this.updateReconcileOrdersToStock.productInventories[k]
                .quantitySold > this.updateReconcileOrdersToStock.quantity
            ) {
              /*
	                               this.v1.quantities[k].quantity.text = 'Quantity sold cannot be more than quantity in this order'; */
              this.v1.quantities[k].quantity.is_valid = false;
              this.v1.is_valid = false;
              this.v1.text =
                "Quantity sold cannot be more than quantity in this order";
              isValid = false;
            }
          }
        }
      }

      if (isValid) {
        let total = 0;
        this.updateReconcileOrdersToStock.productInventories.forEach((item) => {
          total += parseInt(item.quantitySold);
        });
        if (total != parseInt(this.updateReconcileOrdersToStock.quantity)) {
          this.v1.is_valid = false;
          this.v1.text = "Total quantities sold must match the order quantity";
          isValid = false;
        }
      }

      return isValid;
    },

    async getReconcileOrdersToStocks() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          "/Orders/getReconciledList?pageNumber=" +
            this.reconciledOrder.page +
            "&pageSize=" +
            this.reconciledOrder.pageSize +
            (this.filter.pn != "" ? "&productName=" + this.filter.pn : "") +
            (this.filter.pc != "" ? "&productCode=" + this.filter.pc : "") +
            (this.filter.cn != "" ? "&customerId=" + this.filter.cn : "") +
            (this.filter.on != "" ? "&orderNumber=" + this.filter.on : "") +
            (this.filter.reconcileType != ""
              ? "&ReconicilationType=" + this.filter.reconcileType
              : "") +
            (this.filter.startDate != ""
              ? "&startDate=" +
                moment(this.filter.startDate).format("YYYY-MM-DD 00:00:00")
              : "") +
            (this.filter.endDate != ""
              ? "&endDate=" +
                moment(this.filter.endDate).format("YYYY-MM-DD 23:59:59")
              : "") +
            (this.filter.isReconciled != "0"
              ? "&isReconciled=" + this.filter.isReconciled
              : "")
        )
        .then(function(res) {
          this.ReconcileOrdersToStocks = res.body.data;
          this.reconciledOrder.page = res.body.pageNumber;
          this.reconciledOrder.pageSize = res.body.pageSize;
          this.reconciledOrder.count = res.body.count;
          this.reconciledOrder.pageCount = Math.ceil(
            res.body.count / res.body.pageSize
          );
          this.reconciledOrder.hasPrev = res.body.hasPrev;
          this.reconciledOrder.hasNext = res.body.hasNext;
          this.isBusy = false;
          (this.loading = false), $("#mod-filter").modal("hide");
        })
        .catch(function() {
          this.loading = false;
        });
    },
    async getPendingOrder() {
      this.isBusy = true;
      this.isLoading = true;
      await this.$http
        .get(
          "/Orders/getPendingReconcilationList?pageNumber=" +
            this.pendingOrder.page +
            "&pageSize=" +
            this.pendingOrder.pageSize +
            (this.filter1.pn != "" ? "&productName=" + this.filter1.pn : "") +
            (this.filter1.pc != "" ? "&productCode=" + this.filter1.pc : "") +
            (this.filter1.cn != "" ? "&customerId=" + this.filter1.cn : "") +
            (this.filter1.on != "" ? "&orderNumber=" + this.filter1.on : "") +
            (this.filter1.startDate != ""
              ? "&startDate=" +
                moment(this.filter1.startDate).format("YYYY-MM-DD 00:00:00")
              : "") +
            (this.filter1.endDate != ""
              ? "&endDate=" +
                moment(this.filter1.endDate).format("YYYY-MM-DD 23:59:59")
              : "") +
            "&sellerId=" +
            this.user.parentId +
            (this.filter1.isReconciled != "0"
              ? "&isReconciled=" + this.filter1.isReconciled
              : "")
        )
        .then(function(res) {
          this.pendingOrdersToStocks = res.body.data;
          this.pendingOrder.page = res.body.pageNumber;
          this.pendingOrder.pageSize = res.body.pageSize;
          this.pendingOrder.count = res.body.count;
          this.pendingOrder.pageCount = Math.ceil(
            res.body.count / res.body.pageSize
          );
          this.pendingOrder.hasPrev = res.body.hasPrev;
          this.pendingOrder.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.isLoading = false;
          $("#mod-filterPR").modal("hide");
        })
        .catch(function() {
          this.isLoading = false;
        });
    },
    async getOrderreconcilationDetails(id) {
      this.isBusy = true;
      await this.$http
        .get(`/Orders/getReconciliationDetail/${id}`)
        .then(function(res) {
          this.reconciledDetails.name = res.data.customerName;
          this.reconciledDetails.code = res.data.productCode;
          this.reconciledDetails.product = res.data.productName;
          this.reconciledDetails.quantity = res.data.quantityReconciled;
          this.reconciledDetails.list = res.data.details;
          this.isBusy = false;
          this.isModalVisible = true;
          document.body.style.overflow = "hidden";
        })
        .catch(function() {
          this.isBusy = false;
        });
    },

    formatDate(date) {
      return moment(date).format("ll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    formatNumber(val) {
      return helper.formatNumber(val);
    },

    prevPending() {
      this.pendingOrder.page -= 1;
      this.getPendingOrder();
    },

    nextPending() {
      this.pendingOrder.page += 1;
      this.getPendingOrder();
    },
    gotoPagePending(page) {
      this.pendingOrder.page = page;
      this.getPendingOrder();
    },

    changeLimitPending(limit) {
      this.pendingOrder.pageSize = limit;
      this.getPendingOrder();
    },

    prev() {
      this.reconciledOrder.page -= 1;
      this.getReconcileOrdersToStocks();
    },

    next() {
      this.reconciledOrder.page += 1;
      this.getReconcileOrdersToStocks();
    },

    gotoPage(page) {
      this.reconciledOrder.page = page;
      this.getReconcileOrdersToStocks();
    },

    changeLimit(limit) {
      this.reconciledOrder.pageSize = limit;
      this.getReconcileOrdersToStocks();
    },

    openDefaultTab() {
      document.getElementById("defaultOpen").click();
    },
    openTab(evt, cityName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " active";
    },
  },
};
</script>

<style scoped>
.overflow-custom {
  overflow-y: scroll !important;
}
.vh-50 {
  height: 50vh !important;
}

/* Style the tab */
.tab {
  overflow: hidden;
  display: flex;
  padding: 15px;
  /* border: 1px solid #ccc; */
  /* background-color: #fff; */
}

/* Style the buttons inside the tab */
.tab button {
  width: 50%;
  background-color: inherit;
  text-align: center;
  float: left;
  border: none;
  border-bottom: 2px solid #ccc;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  font-size: 14px !important;
  transition: 0.3s;
  font-size: 17px;
}

/* Change background color of buttons on hover */
.tab button:hover {
  /* background-color: #766cea; */
  color: #766cea !important;
}

/* Create an active/current tablink class */
.tab button.active {
  border-bottom: 2px solid #766cea;
  color: #766cea !important;
}

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 6px 12px;
  /* border: 1px solid #ccc; */
  border-top: none;
}
</style>
